import {environment} from "src/environments/environment";
import {Injectable} from "@angular/core";

@Injectable({providedIn: "root"})
export class ConstantService {

  public AUTH_ENDPOINT: string;
  public ADMIN_AUTH_ENDPOINT: string;
  public API_ENDPOINT: string;
  public SOCKET_URL: string;

  constructor() {
    this.AUTH_ENDPOINT = environment.API_ENDPOINT + 'auth/v1/';
    this.ADMIN_AUTH_ENDPOINT = environment.API_ENDPOINT + 'auth/v1/admins/';
    this.API_ENDPOINT = environment.API_ENDPOINT + 'api/v1/';
    this.SOCKET_URL = environment.API_ENDPOINT;
  }

  public static readonly ENCRYPT_SECRET_KEY = environment.ENCRYPT_SECRET_KEY;

}

